// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"yX-z","sponsoredTooltipWrapper":"zX-z","sponsoredTooltip":"AX-z","newCard":"BX-z"};